<template>
  <div>
    <div class="l-container">
      <p></p>
    </div>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  beforeRouteEnter (to, from, next) {
    next(vm => {
      // vm.getContracts()
      vm.getPaymentdetails()
      vm.getPaymentdetailsDelinquent_month()
      vm.getPaymentdetailsDelinquent_two_month()
      vm.getCompanies()
      vm.getOffices()
    })
  },
  methods: {
    // getContracts () {
    //   this.$store.dispatch('getContracts')
    // },

    getPaymentdetails () {
      this.$store.dispatch('getPaymentdetails')
    },

    getPaymentdetailsDelinquent_month () {
      this.$store.dispatch('getPaymentdetailsDelinquent_month')
    },

    getPaymentdetailsDelinquent_two_month () {
      this.$store.dispatch('getPaymentdetailsDelinquent_two_month')
    },

    getCompanies () {
      this.$store.dispatch('getCompanies')
    },

    getOffices () {
      this.$store.dispatch('getOffices')
    }
  },
  mounted () {
  },
  route: {
  }
}
</script>



// WEBPACK FOOTER //
// Paymentdetails.vue?1c77325f